import { X } from 'lucide-react';
import { Button } from '../../ui/button';
import { Label } from '../../ui/label';

interface VariableFieldLabelProps {
    label: string;
    required?: boolean;
    removable?: boolean;
    onRemove?: () => void;
}

export default function VariableFieldLabel({
    label,
    required,
    removable,
    onRemove,
}: VariableFieldLabelProps) {
    return (
        <div className="flex items-center justify-between">
            <Label htmlFor={label} className="text-sm font-medium">
                {label}
                {required && <span className="text-destructive ml-0.5">*</span>}
            </Label>
            {removable && label && (
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={onRemove}
                    className="hover:text-destructive"
                    aria-label={`Remove ${label}`}
                    title={`Remove ${label}`}
                >
                    <X className="h-4 w-4" />
                </Button>
            )}
        </div>
    );
}
